export const stateName = 'profileSettings';